module.exports = __webpack_public_path__ + "img/app_store.3d2b6a8f.png";